// =============================================================================
// Page transition of the public website (see page-transition.ts). Server-safe:
// the layout puts it on <html data-page-transition> for the styles.
//
// The curtain (page-curtain.tsx) is kept aside, off the website: to bring it
// back, set "curtain" here and mount <PageCurtain /> in the [locale] layout.
// =============================================================================

export type PageTransitionVariant = "curtain" | "clip";

export const PAGE_TRANSITION: PageTransitionVariant = "clip";

// =============================================================================
